import React from 'react';
import { useHistory } from 'react-router';
import CONSTANTS from '../../constants';
import NavUtils from '../../NavUtils';
import VPOPbudgetSimulatorApp from '../../components/VPOP/VPOPbudgetSimulatorApp';

function VPOPbudgetSimulator({tenant}) {
    const history = useHistory();
    let hasAccess = NavUtils.hasAppAccess(tenant, CONSTANTS.APPS_BY_APPTYPE.BUDGET_SIMULATION_TOOL);
  
    if(!hasAccess) {
        history.push('/');
    }
      
  return (
    <div>
        <VPOPbudgetSimulatorApp tenantSetting={ tenant }/>
    </div>
  )
}

export default VPOPbudgetSimulator;